import PromoTile from '@/components/homepage/PromoTile';
import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';

export default function GatewayPromoTile({ ctaLabel = '', anchorLinkID = '', margin, isFullBleed, isSetMaxWidth }) {
  return (
    <div className={getComponentMargin(margin)} {...getAnchorId(anchorLinkID)}>
      <PromoTile ctaLabel={ctaLabel} isFullBleed={isFullBleed} isSetMaxWidth={isSetMaxWidth} />
    </div>
  );
}
